import React from 'react';
import './WriteInCounter.css';

/**
 * Write-in counter component
 * Displays current usage and cooldown timer for write-in cards
 */
function WriteInCounter({ stats, limits, blackCardPickCount }) {
  const { perRound, cooldown } = stats;
  const { used } = perRound;

  // Use black card pick count if provided, otherwise fall back to backend limit
  // This shows the actual number of write-ins allowed for this specific card
  const actualLimit = blackCardPickCount || perRound.limit;
  const actualRemaining = Math.max(0, actualLimit - used);
  const isLimitReached = used >= actualLimit;

  return (
    <div className="write-in-counter">
      {/* Usage display */}
      <div className={`usage-indicator ${isLimitReached ? 'limit-reached' : ''}`}>
        <span className="usage-text">
          {used}/{actualLimit} write-ins used this round
        </span>
        {isLimitReached && <span className="limit-warning">⚠️ Limit reached</span>}
      </div>

      {/* Cooldown timer */}
      {cooldown.active && (
        <div className="cooldown-indicator">
          <span className="cooldown-icon">⏰</span>
          <span className="cooldown-text">
            Please wait {cooldown.remaining} second{cooldown.remaining !== 1 ? 's' : ''}
          </span>
        </div>
      )}

      {/* Help text */}
      {!isLimitReached &&
        !cooldown.active &&
        actualRemaining > 0 &&
        actualRemaining < actualLimit && (
          <div className="usage-hint">
            {actualRemaining} more write-in{actualRemaining !== 1 ? 's' : ''} available this round
          </div>
        )}
    </div>
  );
}

export default WriteInCounter;
